import { render, staticRenderFns } from "./FlightLocation.vue?vue&type=template&id=2b9826ee&scoped=true"
import script from "./FlightLocation.vue?vue&type=script&lang=js"
export * from "./FlightLocation.vue?vue&type=script&lang=js"
import style0 from "./FlightLocation.vue?vue&type=style&index=0&id=2b9826ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9826ee",
  null
  
)

export default component.exports